// Static fallback + helpers to read dynamic mock store assembled at creation time.

const STATIC_FALLBACK = {
  name: 'Meu Estabelecimento Teste',
  balance: 1250.5,
  orders: [
    { id: 1, total: 29.9, status: 'Pago' },
    { id: 2, total: 58.0, status: 'Pendente' },
    { id: 3, total: 12.5, status: 'Pago' },
  ],
  _static: true,
};

export const mockStore = STATIC_FALLBACK; // preserve old named export usage

export function getMockStore() {
  try {
    const raw = localStorage.getItem('mock.store.final.v1');
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}
